'use client';

import {
  RADIUS_SCALE,
  SIZE_SCALE,
  GAP_SCALE,
  FLEX,
  MARGIN_BOTTOM,
  PADDING_Y,
} from '@/components/design-system/tokens';
import { Skeleton } from '@/components/ui/Skeleton';

interface ContentLine {
  className?: string;
}

interface GlassyCardSkeletonProps {
  showMedia?: boolean;
  contentLines?: ContentLine[];
  className?: string;
}

export const GlassyCardSkeleton = ({
  showMedia = true,
  contentLines = [],
  className = '',
}: GlassyCardSkeletonProps) => {
  return (
    <div className={`flex flex-col ${GAP_SCALE['3']} ${PADDING_Y['6']} ${className}`}>
      {showMedia && (
        <Skeleton
          className={`${SIZE_SCALE.h48} ${SIZE_SCALE.full} ${RADIUS_SCALE.md} ${MARGIN_BOTTOM['3']}`}
        />
      )}
      <div className={`${FLEX.flexCol} ${GAP_SCALE['2']}`}>
        {contentLines.map((line, index) => (
          <Skeleton key={index} className={line.className ?? `${SIZE_SCALE['4']} w-full`} />
        ))}
      </div>
    </div>
  );
};

interface SectionHeaderSkeletonProps {
  className?: string;
}

export const SectionHeaderSkeleton = ({ className = '' }: SectionHeaderSkeletonProps) => {
  return (
    <div className={`${GAP_SCALE['3']} ${className}`}>
      <Skeleton className={`${SIZE_SCALE['8']} ${SIZE_SCALE.w3_4}`} />
      <Skeleton className={`${SIZE_SCALE['4']} ${SIZE_SCALE.w1_2}`} />
    </div>
  );
};

interface SkeletonLineProps {
  className?: string;
}

export const SkeletonLine = ({ className = '' }: SkeletonLineProps) => {
  return <Skeleton className={`${SIZE_SCALE['4']} ${SIZE_SCALE.full} ${className}`} />;
};

interface SkeletonButtonProps {
  className?: string;
}

export const SkeletonButton = ({ className = '' }: SkeletonButtonProps) => {
  return <Skeleton className={`${SIZE_SCALE['10']} ${SIZE_SCALE.w24} ${className}`} />;
};

interface SkeletonCircleProps {
  className?: string;
}

export const SkeletonCircle = ({ className = '' }: SkeletonCircleProps) => {
  return <Skeleton className={`${SIZE_SCALE['10']} ${SIZE_SCALE.w10} rounded-full ${className}`} />;
};
